import {boolean, route, string, union} from 'react-router-typesafe-routes';

export const chatsRoutesPath = route({
  children: {
    chats: route({
      children: {
        new: route({
          path: 'new',
        }),
      },
      path: 'chats',
      searchParams: {
        cid: string(),
      },
      state: {
        isDM: boolean(),
        postId: string(),
        tab: union(['library']),
        userIds: string().array(),
      },
    }),
    supportChats: route({
      path: 'support-chats',
      searchParams: {
        cid: string().defined(),
      },
    }),
  },
});
